import { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export const useCaptcha = () => {
    const [loadingCaptcha, setLoadingCaptcha] = useState(true);
    const [countdown, setCountdown] = useState(0);
    const [captchaUrl, setCaptchaUrl] = useState(null); // Храним URL blob'а
    const timerRef = useRef(null);

    const fetchCaptcha = useCallback(async (isAutoRefresh = false) => {
        setLoadingCaptcha(true);

        // Очищаем старый URL чтобы не текла память
        if (captchaUrl) {
            URL.revokeObjectURL(captchaUrl);
            setCaptchaUrl(null);
        }
        if (timerRef.current) clearInterval(timerRef.current);
        setCountdown(0);

        try {
            const response = await axios.get(`/api/captcha/?_=${new Date().getTime()}`, {
                responseType: 'blob' // Важно получить именно Blob
            });

            // Создаем локальную ссылку на файл
            const newUrl = URL.createObjectURL(response.data);
            setCaptchaUrl(newUrl);
            setLoadingCaptcha(false);

            // Запускаем таймер на 5 минут
            setCountdown(300);
            timerRef.current = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        toast.info("Код истек и был обновлен.");
                        fetchCaptcha(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

        } catch (error) {
            const errorMessage = "Ошибка загрузки CAPTCHA.";
            if (!isAutoRefresh) {
                if (error.response?.status === 429) {
                    toast.warn("Слишком частые запросы.");
                } else {
                    toast.error(errorMessage);
                }
            }
            setLoadingCaptcha(false);
        }
    }, []); // Зависимости пустые, так как используем ref/setters

    // Начальная загрузка
    useEffect(() => {
        fetchCaptcha(false);
        
        // Cleanup при размонтировании компонента
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
            if (captchaUrl) URL.revokeObjectURL(captchaUrl);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Возвращаем просто URL картинки вместо canvasRef
    return { 
        loadingCaptcha, 
        captchaUrl, 
        fetchCaptcha, 
        countdown 
    };
};